import React from "preact/compat";
import { ModalProps } from "./modal.type";

export const Modal: React.FunctionComponent<ModalProps> = ({
    modalId,
    modalToggle,
    modalStyle,
    children
}) => {
    return (
        <div id={modalId} className={`modal fade ${modalToggle ? 'show in' : ''}`} aria-modal="true" role="dialog" style={{display: modalToggle ? 'block' : 'none'}}>
            <div className={`modal-dialog ${modalStyle ? modalStyle : ''}`}>
                <div className="modal-content p-4">
                    {children}
                </div>
            </div>
        </div>
    )
}
